import { View, Text, Platform } from "react-native";
import { GuidePageHeader, GuideCard, GuideStep, GuideTip, GuideNav, getGuideNav } from "./_components";

const PAGE_HREF = "/(web)/guide/teams";

export default function TeamsPage() {
  if (Platform.OS !== "web") return null;
  const nav = getGuideNav(PAGE_HREF);

  return (
    <View>
      <GuidePageHeader
        icon="people"
        title="Teams"
        subtitle="Tijdens het weekend word je ingedeeld in een team. Samen werk je aan de hoogste score!"
        color="#EC4899"
      />

      {/* Hoe werken teams? */}
      <Text className="text-xl font-bold text-gray-900 mb-4">Hoe werken teams?</Text>
      <Text className="text-base text-gray-600 leading-6 mb-6">
        Elk familie weekend worden teams samengesteld door de commissie. Teams bestaan uit een 
        mix van familieleden en werken samen om de meeste punten te verdienen. Elk team heeft 
        een unieke naam, kleur en avatar.
      </Text>

      <View className="mb-6">
        <GuideCard
          icon="color-palette"
          title="Teamkleur"
          description="Elk team heeft een eigen kleur die terugkomt in de hele app: bij scores, de chat en op het leaderboard."
          color="#EC4899"
        />
        <GuideCard
          icon="person"
          title="Teamcaptain"
          description="Elk team heeft een captain. De captain kan het team aanmoedigen en is het aanspreekpunt voor de commissie."
          color="#3B82F6"
        />
        <GuideCard
          icon="chatbubbles"
          title="Team Chat"
          description="Elk team heeft automatisch een eigen groepschat. Hier kun je strategieën bespreken en je teamgenoten aanmoedigen."
          color="#6366F1"
        />
      </View>

      {/* Team aanpassen */}
      <Text className="text-xl font-bold text-gray-900 mb-4 mt-8">Team Aanpassen</Text>
      <Text className="text-base text-gray-600 leading-6 mb-6">
        Als teamlid kun je bijdragen aan de identiteit van je team. Samen maak je jullie team uniek!
      </Text>

      <View className="mb-6">
        <GuideStep
          step={1}
          title="Teamnaam en slogan"
          description="Bedenk samen een creatieve teamnaam en slogan. Dit verschijnt op het leaderboard en in de app."
          color="#EC4899"
        />
        <GuideStep
          step={2}
          title="Teamkleur kiezen"
          description="Kies een kleur die bij jullie team past. Deze kleur wordt overal in de app gebruikt."
          color="#EC4899"
        />
        <GuideStep
          step={3}
          title="Teamavatar"
          description="Maak een unieke teamavatar met de Avatar Studio. Gebruik stickers, vormen en tekeningen om jullie team te representeren."
          color="#EC4899"
        />
      </View>

      <GuideTip title="Avatar Studio">
        De Avatar Studio is een creatieve tool waarmee je een teamavatar kunt ontwerpen. 
        Je kunt een foto maken of kiezen, stickers toevoegen, vormen tekenen en tekst plaatsen. 
        Het resultaat wordt de profielfoto van je team!
      </GuideTip>

      {/* Teamstand */}
      <Text className="text-xl font-bold text-gray-900 mb-4 mt-8">Teamstand</Text>
      <Text className="text-base text-gray-600 leading-6 mb-6">
        De teamstand toont alle teams gerangschikt op totaalscore. Je kunt zien:
      </Text>

      <View className="mb-6">
        <GuideCard
          icon="trophy"
          title="Totaalscore per team"
          description="De opgetelde punten van alle teamleden uit spellen, uitdagingen en bonuspunten."
          color="#F59E0B"
        />
        <GuideCard
          icon="bar-chart"
          title="Score-uitsplitsing"
          description="Bekijk per team en per speler hoe de punten zijn verdeeld. Wie heeft de meeste punten bijgedragen?"
          color="#3B82F6"
        />
        <GuideCard
          icon="stats-chart"
          title="Scoregeschiedenis"
          description="Een overzicht van wanneer en waardoor punten zijn verdiend: welk spel, welke uitdaging, welke bonus."
          color="#10B981"
        />
      </View>

      <GuideTip variant="success" icon="people" title="Samenwerking is key">
        De teamstand wordt bepaald door de gezamenlijke inzet van alle teamleden. Moedig 
        je teamgenoten aan om mee te doen aan spellen en uitdagingen!
      </GuideTip>

      <GuideNav {...nav} />
    </View>
  );
}
